import {
  PriceProtectionIcon,
  SecureIcon,
  TransparencyIcon,
  WhiteLabelIcon,
} from "./ui/Icons";
import Section from "./ui/Section";

export default function Features() {
  const features = [
    {
      title: "White-label Solutions",
      desc: "Your customers see your brand, we power it behind the scenes. Fully customizable interfaces.",
      icon: <WhiteLabelIcon className="w-8 h-8" />,
    },
    {
      title: "Transparency",
      desc: "Real-time gold rates, instant booking, and clear policies without hidden charges.",
      icon: <TransparencyIcon className="w-8 h-8" />,
    },
    {
      title: "Price Protection",
      desc: "Buy at live rates as you sell and protect your business from price volatility risks.",
      icon: <PriceProtectionIcon className="w-8 h-8" />,
    },
    {
      title: "Secure UPI",
      desc: "Seamless payments backed by UPI infrastructure for total security and reliability.",
      icon: <SecureIcon className="w-8 h-8" />,
    },
  ];

  return (
    <Section id="features" className="bg-white dark:bg-[#0a0a0a]">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 rounded-full bg-[#C9A227]/10 text-[#6b5a1a] dark:text-[#C9A227] text-sm font-semibold mb-6">
            Key Features
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1a1a1a] dark:text-white mb-6">
            Built for Modern Jewellers
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-400 leading-relaxed max-w-3xl mx-auto">
            CaratPay is a fintech platform built exclusively for retail
            jewellers. Our platforms support metal booking and white-labelled
            gold and silver savings schemes through a single integrated system.
          </p>
        </div>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* Feature 1 - Large Card */}
          <div className="lg:col-span-2 group relative overflow-hidden rounded-3xl bg-[#fdfaf2] dark:bg-[#111111] p-8 md:p-10 min-h-[280px] border border-[#C9A227]/10 dark:border-gray-800 transition-all hover:shadow-xl hover:shadow-[#C9A227]/5">
            <div className="absolute top-0 right-0 w-64 h-64 bg-[#C9A227]/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 transition-all group-hover:bg-[#C9A227]/20"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-[#C9A227]/5 rounded-full blur-2xl translate-y-1/2 -translate-x-1/2"></div>

            <div className="relative z-10 h-full flex flex-col">
              <div className="w-14 h-14 rounded-2xl bg-[#C9A227]/10 dark:bg-[#C9A227]/20 flex items-center justify-center text-[#6b5a1a] dark:text-[#C9A227] mb-6 group-hover:scale-110 transition-transform duration-300 shadow-sm">
                {features[0].icon}
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-[#1a1a1a] dark:text-white mb-3">
                {features[0].title}
              </h3>
              <p className="text-gray-600 dark:text-gray-400 text-lg leading-relaxed max-w-md">
                {features[0].desc}
              </p>
            </div>
          </div>

          {/* Feature 2 - Small Card */}
          <div className="group relative overflow-hidden rounded-3xl bg-[#fdfaf2] dark:bg-[#111111] p-8 min-h-[280px] border border-[#C9A227]/10 dark:border-gray-800 transition-all hover:shadow-xl hover:shadow-[#C9A227]/5">
            <div className="absolute top-0 right-0 w-32 h-32 bg-[#C9A227]/10 rounded-full blur-2xl -translate-y-1/2 translate-x-1/2 transition-all group-hover:bg-[#C9A227]/20"></div>

            <div className="relative z-10 h-full flex flex-col">
              <div className="w-14 h-14 rounded-2xl bg-[#C9A227]/10 dark:bg-[#C9A227]/20 flex items-center justify-center text-[#6b5a1a] dark:text-[#C9A227] mb-6 group-hover:scale-110 transition-transform duration-300 shadow-sm">
                {features[1].icon}
              </div>
              <h3 className="text-2xl font-bold text-[#1a1a1a] dark:text-white mb-3">
                {features[1].title}
              </h3>
              <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
                {features[1].desc}
              </p>
            </div>
          </div>

          {/* Feature 3 - Small Card */}
          <div className="group relative overflow-hidden rounded-3xl bg-[#fdfaf2] dark:bg-[#111111] p-8 min-h-[280px] border border-[#C9A227]/10 dark:border-gray-800 transition-all hover:shadow-xl hover:shadow-[#C9A227]/5">
            <div className="absolute bottom-0 left-0 w-32 h-32 bg-[#C9A227]/10 rounded-full blur-2xl translate-y-1/2 -translate-x-1/2 transition-all group-hover:bg-[#C9A227]/20"></div>

            <div className="relative z-10 h-full flex flex-col">
              <div className="w-14 h-14 rounded-2xl bg-[#C9A227]/10 dark:bg-[#C9A227]/20 flex items-center justify-center text-[#6b5a1a] dark:text-[#C9A227] mb-6 group-hover:scale-110 transition-transform duration-300 shadow-sm">
                {features[2].icon}
              </div>
              <h3 className="text-2xl font-bold text-[#1a1a1a] dark:text-white mb-3">
                {features[2].title}
              </h3>
              <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
                {features[2].desc}
              </p>
            </div>
          </div>

          {/* Feature 4 - Large Card (Spanning 2 cols or 1 col depending on layout, let's keep it consistent) */}
          {/* Actually let's make the 4th feature match the grid style. 
               We have 4 features. 
               Card 1: col-span-2
               Card 2: col-span-1
               Card 3: col-span-1
               Card 4: ??
               
               Let's make Card 4 col-span-2 as well, or create a better grid.
               Grid: 3 columns.
               Row 1: [2 cols] [1 col]
               Row 2: [1 col] [2 cols]
           */}

          <div className="lg:col-span-2 group relative overflow-hidden rounded-3xl bg-[#fdfaf2] dark:bg-[#111111] p-8 md:p-10 min-h-[280px] border border-[#C9A227]/10 dark:border-gray-800 transition-all hover:shadow-xl hover:shadow-[#C9A227]/5">
            <div className="absolute top-0 left-0 w-64 h-64 bg-[#C9A227]/10 rounded-full blur-3xl -translate-y-1/2 -translate-x-1/2 transition-all group-hover:bg-[#C9A227]/20"></div>

            <div className="relative z-10 h-full flex flex-col">
              <div className="w-14 h-14 rounded-2xl bg-[#C9A227]/10 dark:bg-[#C9A227]/20 flex items-center justify-center text-[#6b5a1a] dark:text-[#C9A227] mb-6 group-hover:scale-110 transition-transform duration-300 shadow-sm">
                {features[3].icon}
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-[#1a1a1a] dark:text-white mb-3">
                {features[3].title}
              </h3>
              <p className="text-gray-600 dark:text-gray-400 text-lg leading-relaxed max-w-md">
                {features[3].desc}
              </p>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
}
